import React, { useEffect, useRef, useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import { RouteComponentProps, RouteProps, withRouter } from "react-router";
import ScrollToBottom from "react-scroll-to-bottom";
import styled from "styled-components";
import { colors } from "sweet-web/lib/styles";
import { RootState } from "sweet-web/redux";
import * as selectors from "sweet-web/redux/selectors";
import BookingMessage from "./BookingMessage";
import NewMessageBar from "./NewMessageBar";
import TextMessage from "./TextMessage";

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  position: relative;
  height: 100%;
`;

const Messages = styled(ScrollToBottom)`
  flex: 1;
  padding-bottom: 10px;
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: flex-end;
  align-items: center;
  overflow: auto;
  height: 100%;
`;

const Spacer = styled.div`
  height: 40px;
`;

const Bottom = styled.div`
  width: 100%;
  padding: 5px 30px 30px 30px;
  background-color: rgba(255, 255, 255, 0.8);
  position: absolute;
  bottom: 0;
`;

type Props = RouteComponentProps & ConnectedProps<typeof connector>;

const ViewChat: React.FC<Props> = props => {
  const { chatId } = props.match.params as { chatId: string };
  const { uid, chat, messages } = props;

  if (chatId) {
    // sort messages by recency
    const sortedMessages = messages
      ? Object.values(messages).sort((a, b) => a.time - b.time)
      : [];

    const loading = sortedMessages.length === 0;

    return (
      <Wrapper>
        <Messages>
          {!loading &&
            sortedMessages.map((message, i) => {
              switch (message.type) {
                case "MESSAGE":
                  return (
                    <TextMessage
                      key={`chat-${chatId}-text-message-${i}`}
                      chat={chat}
                      message={message}
                      uid={uid}
                    />
                  );

                case "BOOKING":
                  return (
                    <BookingMessage
                      key={`chat-${chatId}-booking-message-${i}`}
                      chat={chat}
                      message={message}
                    />
                  );
              }
            })}
          <Spacer />
          <Spacer />
        </Messages>
        <Bottom>
          <NewMessageBar />
        </Bottom>
      </Wrapper>
    );
  }
};

const mapState = (state: RootState, ownProps: RouteComponentProps) => {
  const { chatId } = ownProps.match.params as { chatId: string };

  return {
    uid: selectors.uid(state),
    chat: selectors.chat(chatId)(state),
    messages: selectors.messages(chatId)(state)
  };
};
const connector = connect(mapState);

export default withRouter(connector(ViewChat));
